// Generated by ReScript, PLEASE EDIT WITH CARE

import * as SolanaWalletJs from "./SolanaWallet.js";

function connectSolanaWallet(prim) {
  return SolanaWalletJs.connectSolanaWallet();
}

function signAndSendBase64Tx(prim0, prim1) {
  return SolanaWalletJs.signAndSendBase64Tx(prim0, prim1);
}

export {
  connectSolanaWallet ,
  signAndSendBase64Tx ,
}
/* ./SolanaWallet.js Not a pure module */
